"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7461],{

/***/ 30938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$F": function() { return /* binding */ CheckoutBtn; },
/* harmony export */   "Bo": function() { return /* binding */ BtnWrapper; },
/* harmony export */   "Eo": function() { return /* binding */ CartBtn; },
/* harmony export */   "RX": function() { return /* binding */ ProductsList; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "Zs": function() { return /* binding */ ListViewSelectBox; },
/* harmony export */   "af": function() { return /* binding */ StickyMenu; },
/* harmony export */   "bz": function() { return /* binding */ PriceBox; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "kI": function() { return /* binding */ FilterWrapper; },
/* harmony export */   "m9": function() { return /* binding */ ProductsSignWrapper; },
/* harmony export */   "n2": function() { return /* binding */ ProductsGrid; },
/* harmony export */   "qx": function() { return /* binding */ MenuBanner; },
/* harmony export */   "qy": function() { return /* binding */ MenuList; },
/* harmony export */   "ze": function() { return /* binding */ TableTypeWrapper; },
/* harmony export */   "zw": function() { return /* binding */ ListViewTypeWrapper; }
/* harmony export */ });
/* unused harmony exports CategoryWrapper, CategorySliderName */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  .p_title {\n    width: 100%;\n    margin-bottom: 30px;\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    & div {\n      margin-bottom: 0px !important;\n    }\n    @media screen and (max-width: 1199px) {\n      display: none;\n    }\n    .breadcrumb {\n      grid-column: 3 span / 3 span;\n    }\n  }\n  .m_title {\n    display: none;\n    @media screen and (max-width: 1199px) {\n      display: flex;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  & span {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 10px;\n    border: 1px solid #ececec;\n    cursor: pointer;\n  }\n\n  .selected {\n    background-color: #3bb77e;\n    color: white;\n    border: 1px solid #3bb77e;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  border: 1px solid #3bb77e;\n  background-color: #f1f1f1;\n  padding: 10px;\n\n  .cnt {\n    font-size: 16px;\n  }\n  .filter {\n    width: fit-content;\n  }\n\n  @media (max-width: 991px) {\n    display: flex;\n    flex-direction: column;\n    .cnt {\n      width: 100%;\n      margin-bottom: 10px;\n    }\n    .filter {\n      width: 100%;\n    }\n  }\n  @media (max-width: 767px) {\n    & span {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: grid;\n  grid-template-columns: ",
        ";\n  grid-column-gap: 10px;\n  grid-row-gap: 20px;\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  word-break: keep-all;\n  margin-top: 50px;\n  & h4 {\n    margin-bottom: 20px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1199px) {\n    /* display: flex;\n    .sidebar-widget {\n      width: 30%;\n      margin-right: 20px;\n    }\n    .banner-img {\n      width: 70%;\n      height: fit-content;\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      grid-column-gap: 20px;\n    } */\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  & img {\n    margin-bottom: 10px;\n  }\n\n  @media screen and (max-width: 1199px) {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-column-gap: 10px;\n    overflow: hidden;\n  }\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: 1199px) {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    grid-column-gap: 10px;\n  }\n  @media (max-width: 991px) {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 545px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  overflow-x: auto;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  color: #253d4e;\n  .header {\n    background-color: #f9f6f6ba;\n  }\n  & tr {\n    text-align: center;\n    :hover {\n      background-color: #f9f6f6ba;\n    }\n  }\n\n  & th {\n    padding: 5px;\n    font-size: 14px;\n    word-break: keep-all;\n  }\n\n  & td {\n    padding: 10px;\n    vertical-align: middle;\n    text-align: center;\n    white-space: nowrap;\n  }\n\n  & a {\n    color: #253d4e;\n  }\n\n  .img {\n    width: 10%;\n    padding: 5px;\n    & a {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n  .name {\n    & a {\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      white-space: pre-wrap;\n      text-overflow: ellipsis;\n      word-break: keep-all;\n      :hover {\n        color: #3bb77e;\n      }\n    }\n  }\n\n  .price {\n    color: #dc3545;\n  }\n\n  .sizes {\n    > div {\n      width: fit-content;\n      margin: 0 auto;\n      text-align: start;\n    }\n  }\n\n  @media (max-width: 991px) {\n    & td {\n      padding: 5px;\n    }\n    .golgi {\n      width: 7%;\n    }\n    .strength {\n      display: none;\n    }\n    .feature {\n      width: 15%;\n    }\n    .sizes {\n      width: 10%;\n    }\n    .onePrice {\n      width: 10%;\n    }\n    .quantity {\n      width: 10%;\n    }\n    .price {\n      width: 13%;\n    }\n  }\n  @media (max-width: 767px) {\n    & th {\n      font-size: 12px;\n    }\n    & td {\n      font-size: 12px;\n    }\n    .img {\n      display: none;\n    }\n    .sizes {\n      width: 13%;\n    }\n    .golgi {\n      width: 10%;\n    }\n    .price {\n      width: 13%;\n    }\n  }\n  @media (max-width: 575px) {\n    & th {\n      font-size: 10px;\n    }\n    & td {\n      font-size: 10px;\n      padding: 5px;\n    }\n    .sizes {\n      display: none;\n    }\n  }\n  @media (max-width: 460px) {\n    .quantity {\n      display: none;\n    }\n    .onePrice {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  word-break: keep-all;\n  @media (max-width: 991px) {\n    font-size: 14px;\n    line-height: 1.5;\n  }\n  @media (max-width: 767px) {\n    font-size: 10px;\n  }\n  @media (max-width: 575px) {\n    font-size: 8px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: #fd7e14;\n  color: #fff;\n  border: 1px solid #fd7e14;\n  margin-bottom: 2px;\n  padding: 4px 12px !important;\n\n  :hover {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  border: 1px solid #3bb77e;\n  padding: 4px 12px !important;\n\n  :hover {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0;\n\n  & > div {\n    & span {\n      text-decoration: line-through;\n      color: #6c757d;\n      opacity: 0.5;\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 10px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0px 5px;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  word-wrap: break-word;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-6cc4c372-0"
})(_templateObject());
var ListViewTypeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6cc4c372-1"
})(_templateObject1());
var ListViewSelectBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6cc4c372-2"
})(_templateObject2());
var FilterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6cc4c372-3"
})(_templateObject3());
var ProductsGrid = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6cc4c372-4"
})(_templateObject4(), function(props) {
    return props.searchTerm ? "repeat(4, 1fr)" : "repeat(4, 1fr)";
});
var ProductsList = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6cc4c372-5"
})(_templateObject5());
var ProductsSignWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6cc4c372-6"
})(_templateObject6());
var StickyMenu = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6cc4c372-7"
})(_templateObject7());
var MenuBanner = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6cc4c372-8"
})(_templateObject8());
var MenuList = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-6cc4c372-9"
})(_templateObject9());
// table type list
var TableTypeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6cc4c372-10"
})(_templateObject10());
var Table = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    componentId: "sc-6cc4c372-11"
})(_templateObject11());
var BtnWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6cc4c372-12"
})(_templateObject12());
var CheckoutBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-6cc4c372-13"
})(_templateObject13());
var CartBtn = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-6cc4c372-14"
})(_templateObject14(), function(props) {
    return props.inCart ? "#3bb77e" : "#fff";
}, function(props) {
    return props.inCart ? "#fff" : "#3bb77e";
});
var PriceBox = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6cc4c372-15"
})(_templateObject15());
// 카테고리 부분
var CategoryWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6cc4c372-16"
})(_templateObject16());
// 카테고리 개별 구분
var CategorySliderName = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-6cc4c372-17"
})(_templateObject17());


/***/ }),

/***/ 17461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64384);
/* harmony import */ var _api_products__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81628);
/* harmony import */ var _common_auth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48106);
/* harmony import */ var _common_splicePrice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8025);
/* harmony import */ var _common_util_getDate__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69644);
/* harmony import */ var _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83173);
/* harmony import */ var _redux_action_cart__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68866);
/* harmony import */ var _common_alert__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55150);
/* harmony import */ var _Proucts_list_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30938);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}














var TableTypeList = function(param) {
    var productList = param.productList, searchList = param.searchList, basketsItems = param.basketsItems, cartItems = param.cartItems, basketsCount = param.basketsCount, dummyList = param.dummyList, _$addToCart = param.addToCart, _$insertBasketsAction = param.insertBasketsAction, purchaseDirect = param.purchaseDirect, addCart = param.addCart, inCart = param.inCart, viewFeature = param.viewFeature, products = param.products;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var inBasket = function(product) {
        return inCart ? inCart(product) : (basketsItems === null || basketsItems === void 0 ? void 0 : basketsItems.find(function(basketsItem) {
            return basketsItem.pcode === product.pcode;
        })) || (cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(cartItem) {
            return cartItem.pcode === product.pcode;
        }));
    };
    // orderType 이 'O' 이거나 없으면 기존 구매 버튼 노출
    var isOrderTypeO = function(product) {
        return !product.orderType || product.orderType === "O";
    };
    // 장바구니 담기
    var handleCart = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (product) {
                            dataLayer.push({
                                ecommerce: null
                            }); // Clear the previous ecommerce object.
                            dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    items: [
                                        {
                                            item_name: product.pname,
                                            item_id: product.pcode,
                                            price: product.price,
                                            item_brand: product.supplier,
                                            item_category: product.category_code.length > 2 ? product.category_code : dummyList === null || dummyList === void 0 ? void 0 : dummyList.category[product.category_code]
                                        }, 
                                    ]
                                }
                            });
                            // 채널톡 장바구니 이벤트
                            window.ChannelIO("track", "AddToCart", {
                                pcode: product.pcode
                            });
                        }
                        if ((0,_common_auth__WEBPACK_IMPORTED_MODULE_7__/* .getCookie */ .ej)("token")) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _$addToCart(product));
                    case 5:
                        return _ctx.abrupt("return", _$insertBasketsAction(product, 1));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCart(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var moveToDetail = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            var body, res, DATE, todays, tempToday, url;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ViewCount",
                            pcode: product.pcode
                        };
                        _ctx.next = 3;
                        return (0,_api_products__WEBPACK_IMPORTED_MODULE_6__/* .ViewCountProduct */ .Ir)(body);
                    case 3:
                        res = _ctx.sent;
                        DATE = (0,_common_util_getDate__WEBPACK_IMPORTED_MODULE_11__/* .getDate */ ._3)();
                        todays = JSON.parse(sessionStorage.getItem("".concat(DATE)) || "[]");
                        tempToday = todays.filter(function(el) {
                            return el === product.pcode;
                        });
                        if (!tempToday.length) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 9:
                        todays.push(product.pcode);
                        sessionStorage.setItem("".concat(DATE), JSON.stringify(todays));
                        url = "/products/".concat(product.ename, "/").concat(product.pcode, "/");
                        router.push(url);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function moveToDetail(product) {
            return _ref.apply(this, arguments);
        };
    }();
    // 전화문의
    var handleTelInquiry = function(product) {
        var tel = "02-6964-6930";
        if (!tel) {
            (0,_common_alert__WEBPACK_IMPORTED_MODULE_9__/* .failAlert */ .qh)("\uC804\uD654\uBC88\uD638 \uC815\uBCF4\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.");
            return;
        }
        window.location.href = "tel:".concat(tel);
    };
    // 채널톡 문의
    var handleChannelTalkInquiry = function() {
        if ( true && window.ChannelIO) {
            window.ChannelIO("show");
        } else {
            (0,_common_alert__WEBPACK_IMPORTED_MODULE_9__/* .failAlert */ .qh)("\uCC44\uB110\uD1A1\uC744 \uC2E4\uD589\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_10__/* .TableTypeWrapper */ .ze, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_10__/* .Table */ .iA, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("thead", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                            className: "header",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "img",
                                    children: "\uC774\uBBF8\uC9C0"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "name",
                                    children: "\uD488\uBA85"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "sizes",
                                    children: "\uC0AC\uC774\uC988"
                                }),
                                (router.query.code === "01" || router.query.code === "02") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                            className: "golgi",
                                            children: "\uACE8"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                            className: "strength",
                                            children: "\uC9C0\uC885"
                                        })
                                    ]
                                }),
                                (router.query.code === "05" || viewFeature) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "feature",
                                    children: "\uC8FC\uC6D0\uB8CC"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "onePrice",
                                    children: "\uB2E8\uAC00"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    className: "quantity",
                                    children: "\uBB36\uC74C \uC218\uB7C9"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    children: "\uD310\uB9E4\uAC00"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("th", {
                                    children: "\uAD6C\uB9E4"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("tbody", {
                        children: (searchList === null || searchList === void 0 ? void 0 : searchList.length) > 0 || (productList === null || productList === void 0 ? void 0 : productList.length) > 0 ? (router.query.search ? searchList : productList).map(function(product, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "img",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/products/".concat(product.ename, "/").concat(product.pcode, "/"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                onClick: function() {
                                                    return moveToDetail(product);
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                    src: product.main_image,
                                                    alt: product.pname
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "name",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/products/".concat(product.ename, "/").concat(product.pcode, "/"),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                onClick: function() {
                                                    return moveToDetail(product);
                                                },
                                                children: product.pname
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "sizes",
                                        children: product.horizontal == 0 && product.vertical == 0 && product.height == 0 ? "-" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            children: [
                                                product.horizontal != 0 ? "\uAC00\uB85C: " + product.horizontal : "",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                                product.vertical != 0 ? "\uC138\uB85C: " + product.vertical : "",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                                product.height != 0 ? "\uB192\uC774: " + product.height : ""
                                            ]
                                        })
                                    }),
                                    (router.query.code === "01" || router.query.code === "02") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                                className: "golgi",
                                                children: product.golgi
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                                className: "strength",
                                                children: product.strength
                                            })
                                        ]
                                    }),
                                    (router.query.code === "05" || viewFeature) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "feature",
                                        children: product.feature ? product.feature : "-"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "onePrice",
                                        children: isOrderTypeO(product) ? Number(product.quantity) < 1 ? "-" : (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(Math.floor(Number(product.discount_price) / Number(product.quantity))) + "\uC6D0" : "-"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "quantity",
                                        children: product.quantity == 0 ? "-" : (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product.quantity) + "\uAC1C"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "price",
                                        children: isOrderTypeO(product) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_10__/* .PriceBox */ .bz, {
                                            children: [
                                                product.salePer > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        children: product.price && " ".concat((0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product.price), "\uC6D0")
                                                    })
                                                }),
                                                (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product.discount_price),
                                                "\uC6D0"
                                            ]
                                        }) : "-" // 또는 "문의" 로 변경 가능
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                        className: "btnWrapper",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_10__/* .BtnWrapper */ .Bo, {
                                            children: product.sold_out === "Y" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    children: "\uD488\uC808"
                                                })
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                children: isOrderTypeO(product) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                    children: [
                                                        purchaseDirect && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_10__/* .CheckoutBtn */ .$F, {
                                                            className: "btn-sm",
                                                            onClick: purchaseDirect(product),
                                                            children: "\uBC14\uB85C \uACB0\uC81C\uD558\uAE30"
                                                        }),
                                                        !inBasket(product) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_10__/* .CartBtn */ .Eo, {
                                                            className: "mobonCart btn-sm",
                                                            onClick: function() {
                                                                return addCart ? addCart(product) : handleCart(product);
                                                            },
                                                            children: "\uC7A5\uBC14\uAD6C\uB2C8 \uB2F4\uAE30"
                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_10__/* .CartBtn */ .Eo, {
                                                            className: "btn-sm",
                                                            onClick: function() {
                                                                return addCart ? addCart(product) : handleCart(product);
                                                            },
                                                            inCart: true,
                                                            children: "\uC7A5\uBC14\uAD6C\uB2C8 \uB2F4\uAE40"
                                                        })
                                                    ]
                                                }) : /* orderType 이 P / T / C 인 경우 → 문의 버튼만 노출 */ /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                    children: [
                                                        product.orderType === "P" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_10__/* .CheckoutBtn */ .$F, {
                                                            className: "btn-sm",
                                                            onClick: function() {
                                                                return moveToDetail(product);
                                                            },
                                                            children: "\uC81C\uC791 \uBB38\uC758"
                                                        }),
                                                        product.orderType === "T" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_10__/* .CheckoutBtn */ .$F, {
                                                            className: "btn-sm",
                                                            onClick: function() {
                                                                return handleTelInquiry(product);
                                                            },
                                                            children: "\uC804\uD654 \uBB38\uC758"
                                                        }),
                                                        product.orderType === "C" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Proucts_list_styles__WEBPACK_IMPORTED_MODULE_10__/* .CheckoutBtn */ .$F, {
                                                            className: "btn-sm",
                                                            onClick: handleChannelTalkInquiry,
                                                            children: "\uCC44\uB110\uD1A1 \uBB38\uC758"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    })
                                ]
                            }, i);
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("tr", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("td", {
                                colSpan: 999,
                                children: "\uC870\uAC74\uC5D0 \uB9DE\uB294 \uC0C1\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
                            })
                        })
                    })
                ]
            })
        })
    });
};
var mapStateToProps = function(state) {
    return {
        products: state.products,
        cartItems: state.cart,
        basketsItems: state.baskets.items,
        basketsCount: state.baskets.count
    };
};
var mapDispatchToProps = {
    addToCart: _redux_action_cart__WEBPACK_IMPORTED_MODULE_13__/* .addToCart */ .Xq,
    insertBasketsAction: _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__/* .insertBasketsAction */ .el
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(TableTypeList));


/***/ })

}]);